import { render, staticRenderFns } from "./areaWorkbench.vue?vue&type=template&id=2926f614&scoped=true"
import script from "./areaWorkbench.vue?vue&type=script&lang=js"
export * from "./areaWorkbench.vue?vue&type=script&lang=js"
import style0 from "./areaWorkbench.vue?vue&type=style&index=0&id=2926f614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2926f614",
  null
  
)

export default component.exports